import { render, staticRenderFns } from "./GenerateStatementBtn.vue?vue&type=template&id=a6bdb24e&"
import script from "./GenerateStatementBtn.vue?vue&type=script&lang=js&"
export * from "./GenerateStatementBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports